import { fetcher } from "@/shared/core-configs";
import { LocalProductInput } from "../types/LocalProduct";
import { API } from "@/config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_EXTERNAL_PRODUCTS_FETCH_KEY } from "./useGetLocalProduct";
import { UpdateStockError } from "@/core/common/types";
import { productApi } from "@/shared/core-products";

export const updateLocalProduct = async (
  id: string,
  updateLocalProduct: Partial<LocalProductInput>,
): Promise<LocalProductInput> => {
  const response = await fetcher.put(
    `${API.GESLUB}/external-product/${id}`,
    updateLocalProduct,
  );
  return response.data;
};

export const useUpdateLocalProduct = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    LocalProductInput,
    UpdateStockError,
    {
      id: string;
      updateLocalProducts: Partial<LocalProductInput>;
      imageFiles?: File[];
    }
  >({
    mutationFn: async ({ id, updateLocalProducts, imageFiles }) => {
      const result = await updateLocalProduct(id, updateLocalProducts);
      if (imageFiles && imageFiles.length > 0) {
        await productApi.uploadImageLocalProduct(id, imageFiles[0]);
      }
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_EXTERNAL_PRODUCTS_FETCH_KEY],
      });
    },
  });
  return {
    mutate: mutation.mutate,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isPending: mutation.isPending,
    error: mutation.error,
  };
};
